import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/collections/redux/actions';
import * as commonActions from '../../features/common/redux/actions';
import CustomConstraints from './collection/constraints/CustomConstraints';
import CustomLoader from '../common/CustomLoader';
import CollectionHeaderNav from './CollectionHeaderNav';
import types from '../../common/formElements/CollectionSectionType';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { CONSTRAINT } from 'drapcode-constant';
export class Constraints extends Component {
  static propTypes = {
    collections: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    commonActions: PropTypes.object.isRequired,
  };
  componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, collectionId, version } = match.params;
    actions.loadProjectCollections({ projectId, version });
    actions.loadProjectCollectionDetail({ projectId, collectionId, version });
    actions.getPermissionFlags({ projectId });
    commonActions.loadCollectionChange();
  }

  render() {
    const { collections, match, actions, commonActions, common } = this.props;
    const { projectId, collectionId, version } = match.params;
    const {
      loadProjectCollectionsPending,
      loadProjectCollectionDetailPending,
      createCollectionConstraintPending,
      updateConstraintOfCollectionPending,
      selectedCollection,
      projectCollections,
      deleteCollectionConstraintPending,
      permissionFlags,
    } = collections;
    const { updatedCollections } = common;
    let permissionsArray = [];
    if (permissionFlags && permissionFlags.length > 0) {
      permissionsArray = permissionFlags || [];
    }

    const showDerivedConstraintLoader =
      createCollectionConstraintPending || updateConstraintOfCollectionPending;
    const showConstraintDeleteLoader = deleteCollectionConstraintPending;
    return (
      <CommonPageComponent parentClassName="">
        <CollectionHeaderNav
          label={types.CONSTRAINT}
          projectId={projectId}
          version={version}
          selectedCollection={selectedCollection}
          loadProjectCollectionsPending={loadProjectCollectionsPending}
          loadProjectCollectionDetailPending={loadProjectCollectionDetailPending}
        />
        {loadProjectCollectionsPending ||
          (loadProjectCollectionDetailPending && (
            <div className="text-center">
              <CustomLoader
                loading={loadProjectCollectionsPending || loadProjectCollectionDetailPending}
                size="20px"
                color="#303453"
              />
            </div>
          ))}
        {selectedCollection && (
          <CustomConstraints
            actions={actions}
            commonActions={commonActions}
            projectId={projectId}
            version={version}
            constraints={selectedCollection.constraints}
            collection={selectedCollection}
            showDerivedConstraintLoader={showDerivedConstraintLoader}
            showConstraintDeleteLoader={showConstraintDeleteLoader}
            deleteFlag={permissionsArray.includes(CONSTRAINT)}
            updatedCollections={updatedCollections}
          />
        )}
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    collections: state.collections,
    common: state.common,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    commonActions: bindActionCreators({ ...commonActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Constraints);
